import React from 'react'

const LocationTargetWhiteSvg = ({ width }) => {
  return (
    <svg
      id='location-target-svgrepo-com'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 22 22'
    >
      <path
        id='Path_3266'
        data-name='Path 3266'
        d='M8.75,11.5A2.75,2.75,0,1,0,6,8.75,2.75,2.75,0,0,0,8.75,11.5Z'
        transform='translate(2.25 2.25)'
        fill='#fff'
      />
      <path
        id='Path_3267'
        data-name='Path 3267'
        d='M2.864,9.625A8.257,8.257,0,0,1,9.625,2.864V0h2.75V2.864a8.257,8.257,0,0,1,6.761,6.761H22v2.75H19.136a8.257,8.257,0,0,1-6.761,6.761V22H9.625V19.136a8.257,8.257,0,0,1-6.761-6.761H0V9.625ZM5.5,11A5.5,5.5,0,1,1,11,16.5,5.5,5.5,0,0,1,5.5,11Z'
        fill='#fff'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default LocationTargetWhiteSvg
